var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomOutIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.002,
    viewBox: "0 0 20 20.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15160",
    "data-name": "Path 15160",
    d: "M14818.638,17929.5a.873.873,0,0,1-.611-.254l-3.875-3.891-.176-.182-.2.16a8.894,8.894,0,1,1,1.563-1.564l-.16.2,4.061,4.055a.854.854,0,0,1,.264.615.9.9,0,0,1-.864.863Zm-10.285-18.289a7.141,7.141,0,1,0,7.139,7.141A7.147,7.147,0,0,0,14808.353,17911.211Zm-.858,8h-1.424a.856.856,0,1,1,0-1.713h4.569a.856.856,0,0,1,0,1.713h-3.146Z",
    transform: "translate(-14799.502 -17909.498)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutIconDark);
export default __webpack_public_path__ + "static/media/zoom-out-icon-dark.bddbe53878966eac6c50f596d45000c5.svg";
export { ForwardRef as ReactComponent };